import { gql } from "graphql-tag";

export const MOVE_IN_INTERESTS = gql`
  mutation MoveInApplicants(
    $interestIds: [ID!],
    $interestListIds: [ID!]!,
    $moveInDate: String!,
    $unitNumber: String
  ) {
    changeInterestsStatus(
      interestIds: $interestIds
      interestListIds: $interestListIds
      status: "Moved In"
      actionDate: $moveInDate
      unitNumber: $unitNumber
    )
  }
`;
